import { Alert } from "antd";
import { AlertProps } from "./type";

function AntAlert(props: AlertProps) {
  return <Alert {...props} />;
}

export { AntAlert as Alert };
